/**
 * @generated SignedSource<<194696cdd6e10ad76310d7c3cd3a93ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetSupplierAmountOverrideInput = {
  id: string;
  netAmount: number;
  note?: string | null | undefined;
};
export type EditSupplierAmountOverrideDialogMutation$variables = {
  input: SetSupplierAmountOverrideInput;
};
export type EditSupplierAmountOverrideDialogMutation$data = {
  readonly setSupplierAmountOverride: {
    readonly id: string;
    readonly netAmount: number;
    readonly note: string | null | undefined;
    readonly setAt: any;
    readonly setBy: string;
  };
};
export type EditSupplierAmountOverrideDialogMutation = {
  response: EditSupplierAmountOverrideDialogMutation$data;
  variables: EditSupplierAmountOverrideDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SupplierAmountOverride",
    "kind": "LinkedField",
    "name": "setSupplierAmountOverride",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "netAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "note",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSupplierAmountOverrideDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditSupplierAmountOverrideDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "821ebccf12cad8ee02c697d6fcad8f83",
    "id": null,
    "metadata": {},
    "name": "EditSupplierAmountOverrideDialogMutation",
    "operationKind": "mutation",
    "text": "mutation EditSupplierAmountOverrideDialogMutation(\n  $input: SetSupplierAmountOverrideInput!\n) {\n  setSupplierAmountOverride(input: $input) {\n    id\n    netAmount\n    note\n    setBy\n    setAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3f4652a13aa43147bf7299942a52e1b";

export default node;
